<template>
    <div id="service-list-filters-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Filter Health Insurance Claim Forms</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body px-0">
                    <div v-if="message" class="alert alert-danger" role="alert">{{ message }}</div>

                    <!-- Shared Status -->
                    <div v-if="showShareStatus" class="px-3 pb-3 border-bottom">
                        <div class="d-flex justify-content-between">
                            <div class="font-weight-bold">Share Status</div>
                            <div class="text-muted">
                                {{ shareStatusOptions.find(x => x.value === filters.shareStatus).name }}
                                <span class="pl-3" @click="shareStatusToggle = !shareStatusToggle"><i :class="['fas', shareStatusToggle ? 'fa-chevron-up' : 'fa-chevron-down', 'fa-lg']"></i></span>
                            </div>
                        </div>
                        <div v-if="shareStatusToggle" class="d-flex flex-wrap justify-content-around mt-2">
                            <button v-for="shareStatusOption in shareStatusOptions" 
                                :key="'service-list-filters-share-status-option-' + shareStatusOption.value" 
                                :class="['btn', {'btn-outline-primary': shareStatusOption.value == filters.shareStatus}, 'mx-3']"  
                                @click="filters.shareStatus = shareStatusOption.value">{{ shareStatusOption.name }}</button>                            
                        </div>
                    </div>

                    <!-- Payment Status -->
                    <div class="p-3 border-bottom">
                        <div class="d-flex justify-content-between">
                            <div class="font-weight-bold">Payment Status</div>
                            <div class="text-muted">
                                {{ paymentStatusOptions.find(x => x.value === filters.paymentStatus).name }}
                                <span class="pl-3" @click="paymentStatusToggle = !paymentStatusToggle"><i :class="['fas', paymentStatusToggle ? 'fa-chevron-up' : 'fa-chevron-down', 'fa-lg']"></i></span>
                            </div>
                        </div>
                        <div v-if="paymentStatusToggle" class="d-flex flex-wrap justify-content-around mt-2">
                            <button v-for="paymentStatusOption in paymentStatusOptions" 
                                :key="'service-list-filters-payment-status-option-' + paymentStatusOption.value" 
                                :class="['btn', {'btn-outline-primary': paymentStatusOption.value == filters.paymentStatus}, 'mx-3']"  
                                @click="filters.paymentStatus = paymentStatusOption.value">{{ paymentStatusOption.name }}</button>                            
                        </div>
                    </div>

                    <!-- Remit Status -->
                    <div class="p-3 border-bottom">
                        <div class="d-flex justify-content-between">
                            <div class="font-weight-bold">Remits</div>
                            <div class="text-muted">
                                {{ booleanOptions.find(x => x.value === filters.hasRemit).name }}
                                <span class="pl-3" @click="remitToggle = !remitToggle"><i :class="['fas', remitToggle ? 'fa-chevron-up' : 'fa-chevron-down', 'fa-lg']"></i></span>
                            </div>
                        </div>
                        <div v-if="remitToggle" class="mt-2">
                            <div>Claim has associated remits?</div>
                            <div class="text-center">
                                <button v-for="booleanOption in booleanOptions" 
                                    :key="'service-list-filters-remit-status-option-' + booleanOption.value" 
                                    :class="['btn', {'btn-outline-primary': booleanOption.value == filters.hasRemit}, 'mx-3']"  
                                    @click="filters.hasRemit = booleanOption.value">{{ booleanOption.name }}</button>
                            </div>                           
                        </div>
                    </div>

                    <!-- Authorization Status -->
                    <div class="p-3 border-bottom">
                        <div class="d-flex justify-content-between">
                            <div>
                                <span class="font-weight-bold">Authorizations</span>
                                <span class="font-small-italic text-muted">(LWC Form 1010)</span>
                            </div>
                            <div class="text-muted">
                                {{ booleanOptions.find(x => x.value === filters.hasAuths).name }}
                                <span class="pl-3" @click="authToggle = !authToggle"><i :class="['fas', authToggle ? 'fa-chevron-up' : 'fa-chevron-down', 'fa-lg']"></i></span>
                            </div>
                        </div>
                        <div v-if="authToggle" class="mt-2">
                            <div>Claim has authorizations?</div>
                            <div class="text-center">
                                <button v-for="booleanOption in booleanOptions" 
                                    :key="'service-list-filters-auth-status-option-' + booleanOption.value" 
                                    :class="['btn', {'btn-outline-primary': booleanOption.value == filters.hasAuths}, 'mx-3']"  
                                    @click="filters.hasAuths = booleanOption.value">{{ booleanOption.name }}</button>
                            </div>                           
                        </div>
                    </div>

                    <!-- 1008 Status -->
                    <div class="p-3 border-bottom">
                        <div class="d-flex justify-content-between">
                            <div>
                                <span class="font-weight-bold">Compensation Disputes</span>
                                <span class="font-small-italic text-muted">(LWC Form 1008)</span>
                            </div>
                            <div class="text-muted">
                                {{ booleanOptions.find(x => x.value === filters.hasDispute).name }}
                                <span class="pl-3" @click="disputeToggle = !disputeToggle"><i :class="['fas', disputeToggle ? 'fa-chevron-up' : 'fa-chevron-down', 'fa-lg']"></i></span>
                            </div>
                        </div>
                        <div v-if="disputeToggle" class="mt-2">
                            <div>Claim is included in a compensation dispute?</div>
                            <div class="text-center">
                                <button v-for="booleanOption in booleanOptions" 
                                    :key="'service-list-filters-dispute-status-option-' + booleanOption.value" 
                                    :class="['btn', {'btn-outline-primary': booleanOption.value == filters.hasDispute}, 'mx-3']"  
                                    @click="filters.hasDispute = booleanOption.value">{{ booleanOption.name }}</button>
                                </div>                           
                        </div>
                    </div>                                                       

                    <!-- Days Outstanding -->
                    <div class="p-3 border-bottom">
                        <div class="d-flex justify-content-between">
                            <div class="font-weight-bold">Days Outstanding</div>
                            <div class="text-muted">
                                {{ comparisonOptions.find(x => x.value == filters.daysOperator).name }}
                                <span v-if="filters.daysOperator === 'between'">{{ filters.daysStart }} and {{ filters.daysEnd }}</span>
                                <span v-else-if="(filters.daysOperator !== 'any') && filters.daysStart">{{ filters.daysStart }}</span>
                                <span class="pl-3" @click="daysToggle = !daysToggle"><i :class="['fas', daysToggle ? 'fa-chevron-up' : 'fa-chevron-down', 'fa-lg']"></i></span>
                            </div>
                        </div>
                        <div v-if="daysToggle" class="d-flex flex-wrap justify-content-start mt-2">
                            <div class="mr-3">
                                <select class="custom-select custom-select-sm" v-model="filters.daysOperator">
                                    <option v-for="comparisonOption in comparisonOptions" :key="'service-list-filters-days-option-' + comparisonOption.value" :value="comparisonOption.value">{{ comparisonOption.name }}</option>
                                </select>
                            </div>
                            <div v-if="filters.daysOperator === 'between'" class="form-inline ml-3">
                                <input type="number" class="form-control form-control-sm" min="0" v-model="filters.daysStart" size="8" />
                                <span class="mx-2">and</span>
                                <input type="number" class="form-control form-control-sm" min="0" v-model="filters.daysEnd" size="8" />
                            </div>
                            <div v-else-if="filters.daysOperator !== 'any'">
                                <input type="number" class="form-control form-control-sm" min="0" v-model="filters.daysStart" size="8" />
                            </div>              
                        </div>                                                       
                    </div>

                    <!-- Estimated Reimbursement -->
                    <div class="p-3 border-bottom">
                        <div class="d-flex justify-content-between">
                            <div class="font-weight-bold">Estimated Reimbursement</div>
                            <div class="text-muted">
                                {{ comparisonOptions.find(x => x.value === filters.reimbursementOperator).name }}
                                <span v-if="filters.reimbursementOperator === 'between'">{{ filters.reimbursementStart | currency }} and {{ filters.reimbursementEnd | currency }}</span>
                                <span v-else-if="(filters.reimbursementOperator !== 'any') && filters.reimbursementStart">{{ filters.reimbursementStart | currency }}</span>                                
                                <span class="pl-3" @click="reimbursementToggle = !reimbursementToggle"><i :class="['fas', reimbursementToggle ? 'fa-chevron-up' : 'fa-chevron-down', 'fa-lg']"></i></span>
                            </div>                            
                        </div>
                        <div v-if="reimbursementToggle" class="d-flex flex-wrap justify-content-start mt-2">
                            <div class="mr-3">
                                <select class="custom-select custom-select-sm" v-model="filters.reimbursementOperator">
                                    <option v-for="comparisonOption in comparisonOptions" :key="'service-list-filters-reimbursement-option-' + comparisonOption.value" :value="comparisonOption.value">{{ comparisonOption.name }}</option>
                                </select>
                            </div>
                            <div v-if="filters.reimbursementOperator === 'between'" class="form-inline ml-3">
                                <input type="number" class="form-control form-control-sm" min="0.00" step="0.01" v-model="filters.reimbursementStart" size="10" />
                                <span class="mx-2">and</span>
                                <input type="number" class="form-control form-control-sm" min="0.00" step="0.01" v-model="filters.reimbursementEnd" size="10" />
                            </div>
                            <div v-else-if="filters.reimbursementOperator !== 'any'">
                                <input type="number" class="form-control form-control-sm" min="0.00" step="0.01" v-model="filters.reimbursementStart" size="10" />
                            </div>              
                        </div>                        
                    </div>

                    <!-- Paid Amount -->
                    <div class="p-3 border-bottom">
                        <div class="d-flex justify-content-between">
                            <div class="font-weight-bold">Paid Amount</div>
                            <div class="text-muted">
                                <span v-if="filters.paidOperator === 'no-payments'">No Payments</span>
                                <span v-else>{{ comparisonOptions.find(x => x.value === filters.paidOperator).name }}</span>
                                <span v-if="filters.paidOperator === 'between'">{{ filters.paidStart | currency }} and {{ filters.paidEnd | currency }}</span>
                                <span v-else-if="(filters.paidOperator !== 'any') && filters.paidStart">{{ filters.paidStart | currency }}</span>                                
                                <span class="pl-3" @click="paidToggle = !paidToggle"><i :class="['fas', paidToggle ? 'fa-chevron-up' : 'fa-chevron-down', 'fa-lg']"></i></span>
                            </div>                             
                        </div>
                        <div v-if="paidToggle" class="d-flex flex-wrap justify-content-start mt-2">
                            <div class="mr-3">
                                <select class="custom-select custom-select-sm" v-model="filters.paidOperator">
                                    <option v-for="comparisonOption in comparisonOptions" :key="'service-list-filters-paid-option-' + comparisonOption.value" :value="comparisonOption.value">{{ comparisonOption.name }}</option>
                                    <option value="no-payments">No Payments</option>
                                </select>
                            </div>
                            <div v-if="filters.paidOperator === 'between'" class="form-inline ml-3">
                                <input type="number" class="form-control form-control-sm" min="0.00" step="0.01" v-model="filters.paidStart" size="10" />
                                <span class="mx-2">and</span>
                                <input type="number" class="form-control form-control-sm" min="0.00" step="0.01" v-model="filters.paidEnd" size="10" />
                            </div>                            
                            <div v-else-if="filters.paidOperator !== 'any' && filters.paidOperator !== 'no-payments'">
                                <input type="number" class="form-control form-control-sm" min="0.00" step="0.01" v-model="filters.paidStart" size="10" />
                            </div>              
                        </div>                         
                    </div>                 

                    <!-- Balance -->
                    <div class="p-3 border-bottom">
                        <div class="d-flex justify-content-between">
                            <div class="font-weight-bold">Balance</div>
                            <div class="text-muted">
                                {{ comparisonOptions.find(x => x.value === filters.balanceOperator).name }}
                                <span v-if="filters.balanceOperator === 'between'">{{ filters.balanceStart | currency }} and {{ filters.balanceEnd | currency }}</span>
                                <span v-else-if="(filters.balanceOperator !== 'any') && filters.balanceStart">{{ filters.balanceStart | currency }}</span>                                  
                                <span class="pl-3" @click="balanceToggle = !balanceToggle"><i :class="['fas', balanceToggle ? 'fa-chevron-up' : 'fa-chevron-down', 'fa-lg']"></i></span>
                            </div>                             
                        </div>
                        <div v-if="balanceToggle" class="d-flex flex-wrap justify-content-start mt-2">
                            <div class="mr-3">
                                <select class="custom-select custom-select-sm" v-model="filters.balanceOperator">
                                    <option v-for="comparisonOption in comparisonOptions" :key="'service-list-filters-balance-option-' + comparisonOption.value" :value="comparisonOption.value">{{ comparisonOption.name }}</option>
                                </select>
                            </div>
                            <div v-if="filters.balanceOperator === 'between'" class="form-inline ml-3">
                                <input type="number" class="form-control form-control-sm" min="0.00" step="0.01" v-model="filters.balanceStart" size="10" />
                                <span class="mx-2">and</span>
                                <input type="number" class="form-control form-control-sm" min="0.00" step="0.01" v-model="filters.balanceEnd" size="10" />
                            </div>
                            <div v-else-if="filters.balanceOperator !== 'any'">
                                <input type="number" class="form-control form-control-sm" min="0.00" step="0.01" v-model="filters.balanceStart" size="10" />
                            </div>              
                        </div>                         
                    </div>

                    <!-- Submit -->
                    <div class="p-3 border-bottom">
                        <div class="d-flex justify-content-between">
                            <div class="font-weight-bold">Submitted</div>
                            <div class="text-muted">
                                {{ comparisonOptions.find(x => x.value === filters.submitOperator).name }}
                                <span v-if="filters.submitOperator === 'between'">{{ filters.submitStart }} and {{ filters.submitEnd }}</span>
                                <span v-else-if="(filters.submitOperator !== 'any') && filters.submitStart">{{ filters.submitStart }}</span>                                  
                                <span class="pl-3" @click="submitToggle = !submitToggle"><i :class="['fas', submitToggle ? 'fa-chevron-up' : 'fa-chevron-down', 'fa-lg']"></i></span>
                            </div>                             
                        </div>
                        <div v-if="submitToggle" class="d-flex flex-wrap justify-content-start mt-2">
                            <div class="mr-3">
                                <select class="custom-select custom-select-sm" v-model="filters.submitOperator">
                                    <option v-for="comparisonOption in comparisonOptions" :key="'service-list-filters-submit-option-' + comparisonOption.value" :value="comparisonOption.value">{{ comparisonOption.name }}</option>
                                </select>
                            </div>
                            <div v-if="filters.submitOperator === 'between'" class="form-inline ml-3">
                                <input type="date" class="form-control form-control-sm" v-model="filters.submitStart" />
                                <span class="mx-2">and</span>
                                <input type="date" class="form-control form-control-sm" v-model="filters.submitEnd" />
                            </div>
                            <div v-else-if="filters.submitOperator !== 'any'">
                                <input type="date" class="form-control form-control-sm" v-model="filters.submitStart" />
                            </div>              
                        </div>                         
                    </div>

                    <!-- Date of Service -->
                    <div class="p-3 border-bottom">
                        <div class="d-flex justify-content-between">
                            <div>
                                <span class="font-weight-bold">Date of Service</span>
                                <span class="font-small-italic text-muted">(DOS)</span>
                            </div>
                            <div class="text-muted">
                                {{ comparisonOptions.find(x => x.value === filters.dosOperator).name }}
                                <span v-if="filters.dosOperator === 'between'">{{ filters.dosStart }} and {{ filters.dosEnd }}</span>
                                <span v-else-if="(filters.dosOperator !== 'any') && filters.dosStart">{{ filters.dosStart }}</span>                                  
                                <span class="pl-3" @click="dosToggle = !dosToggle"><i :class="['fas', dosToggle ? 'fa-chevron-up' : 'fa-chevron-down', 'fa-lg']"></i></span>
                            </div>                             
                        </div>
                        <div v-if="dosToggle" class="d-flex flex-wrap justify-content-start mt-2">
                            <div class="mr-3">
                                <select class="custom-select custom-select-sm" v-model="filters.dosOperator">
                                    <option v-for="comparisonOption in comparisonOptions" :key="'service-list-filters-dos-option-' + comparisonOption.value" :value="comparisonOption.value">{{ comparisonOption.name }}</option>
                                </select>
                            </div>
                            <div v-if="filters.dosOperator === 'between'" class="form-inline ml-3">
                                <input type="date" class="form-control form-control-sm" v-model="filters.dosStart" />
                                <span class="mx-2">and</span>
                                <input type="date" class="form-control form-control-sm" v-model="filters.dosEnd" />
                            </div>
                            <div v-else-if="filters.dosOperator !== 'any'">
                                <input type="date" class="form-control form-control-sm" v-model="filters.dosStart" />
                            </div>              
                        </div>                         
                    </div>

                    <!-- Document Tag -->
                    <div class="px-3 pt-3">
                        <div class="d-flex justify-content-between">
                            <div class="font-weight-bold">Tag</div>
                            <div class="text-muted">
                                {{ tagInclusionOptions.find(x => x.value === this.filters.tagInclusion).name }}
                                {{ filters.tag }}
                                <span class="pl-3" @click="tagToggle = !tagToggle"><i :class="['fas', tagToggle ? 'fa-chevron-up' : 'fa-chevron-down', 'fa-lg']"></i></span>
                            </div>
                        </div>
                        <div v-if="tagToggle" class="d-flex flex-wrap justify-content-start mt-2">
                            <div class="mr-3">
                                <select class="custom-select custom-select-sm" v-model="filters.tagInclusion">
                                    <option v-for="tagInclusionOption in tagInclusionOptions" :key="'service-list-filters-tag-inclusion-option-' + tagInclusionOption.value" :value="tagInclusionOption.value">{{ tagInclusionOption.name }}</option>
                                </select>
                            </div>
                            <div class="mr-3">
                                <select class="custom-select custom-select-sm" v-model="filters.tag">
                                    <option v-for="tagOption in tagOptions" :key="'service-list-filters-tag-inclusion-option-' + tagOption.replace(/\s+/g, '-').toLowerCase()" :value="tagOption">{{ tagOption }}</option>
                                </select>
                            </div>                        
                        </div>
                    </div>                                                                                  

                </div>
                <div class="modal-footer">
                    <a href="javascript:void(0)" class="mr-auto" @click="reset">Reset Filters</a>
                    <button type="button" class="btn btn-primary" @click="apply()">Apply</button>
                </div>
            </div>
        </div>
    </div>                   
</template>

<script>
export default {
    data() {
        return {
            filters: {
                shareStatus: 'all',
                paymentStatus: 'all',
                hasRemit: 'all',
                hasAuths: 'all',
                hasDispute: 'all',
                daysOperator: 'any',
                daysStart: '',
                daysEnd: '',
                reimbursementOperator: 'any',
                reimbursementStart: '',
                reimbursementEnd: '',
                paidOperator: 'any',
                paidStart: '',
                paidEnd: '',
                balanceOperator: 'any',
                balanceStart: '',
                balanceEnd: '',
                submitOperator: 'any',
                submitStart: '',
                submitEnd: '',
                dosOperator: 'any',
                dosStart: '',
                dosEnd: '',
                tagInclusion: 'include',
                tag: 'Any'                
            },
            filter: Function,
            message : null,
            shareStatusOptions: [
                { value: 'all', name: 'All'},
                { value: 'shared', name: 'Shared'},
                { value: 'unshared', name: 'Unshared'}
            ],
            shareStatusToggle: false,
            showShareStatus: true,
            paymentStatusOptions: [
                { value: 'all', name: 'All'},
                { value: 'inprogress', name: 'In Progress'},
                { value: 'paid', name: 'Paid'},
                { value: 'unpaid', name: 'Unpaid'},
                { value: 'underpaid', name: 'Under Paid'},
                { value: 'latepaid', name: 'Paid Late'}
            ],
            paymentStatusToggle: false,
            booleanOptions: [
                { value: 'all', name: 'All'},
                { value: '1', name: 'Yes'},
                { value: '0', name: 'No' }
            ],
            remitToggle: false,
            authToggle: false,
            disputeToggle: false,        
            comparisonOptions: [
                { value: 'any', name: 'Any'},
                { value: '=', name: '= Equal To'},
                { value: '!=', name: '≠ Not Equal To'},
                { value: '<', name: '< Less Than'},
                { value: '>', name: '> Greater Than'},
                { value: 'between', name: 'Between'}
            ],            
            daysToggle: false,
            reimbursementToggle: false,
            paidToggle: false,
            balanceToggle: false,
            submitToggle: false,
            dosToggle: false,
            tagInclusionOptions: [
                { value: 'include', name: 'Include' },
                { value: 'exclude', name: 'Exclude' }
            ],
            tagToggle: false,
            tagOptions: []
        }
    },
    methods: {
        show: function (filters, callback) {
            this.filters = filters;
            this.filter = callback;

            axios.get('/ajax/services/filters')
            .then(response => {

                this.tagOptions = response.data.tag_options;
                this.showShareStatus = response.data.show_share_status;

                // if the tag we are currently filtering on has been deleted clear the tag filter
                if (!this.tagOptions.some(t => t.toLowerCase() === this.filters.tag.toLowerCase())) {
                    this.filtes.tagInclusion = 'inlcude';
                    this.filters.tag = 'Any';
                }

                $('#service-list-filters-modal').modal('show');
            })
            .catch(error => {
                console.log(error.response);
            })
        },
        reset: function () {
            this.filters.shareStatus = 'all';
            this.filters.paymentStatus = 'all';
            this.filters.hasRemit = 'all';
            this.filters.hasAuths = 'all';
            this.filters.hasDispute ='all';
            this.filters.daysOperator = 'any';
            this.filters.daysStart = '',
            this.filters.daysEnd = '',
            this.filters.reimbursementOperator = 'any';
            this.filters.reimbursementStart = '';
            this.filters.reimbursementEnd = '';
            this.filters.paidOperator = 'any';
            this.filters.paidStart = '';
            this.filters.paidEnd = '';
            this.filters.balanceOperator = 'any';
            this.filters.balanceStart = '';
            this.filters.balanceEnd = '';
            this.filters.submitOperator = 'any';
            this.filters.submitStart = '';
            this.filters.submitEnd = '';
            this.filters.dosOperator = 'any';
            this.filters.dosStart = '';
            this.filters.dosEnd = '';
            this.filters.tagInclusion = 'include';
            this.filters.tag = 'Any';                                
        },
        apply: function () {
            $('#service-list-filters-modal').modal('hide');
            this.filter(this.filters);
        }
    },
    created() {
        eventHub.$on('show-service-list-filters', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-service-list-filters');
    }      
}
</script>

<style scoped>
    .chevron {
        font-size: 2.5em;
    }

    .font-small-italic {
        font-size: .75em;
        font-style: italic;
    }    
</style>